import LogoValais from "../theme/images/logo_oseo_valais_retina.png";
import LogoTessin from "../theme/images/sos-ticino-logo.png";

export const customers = {
  sosticino: "sosticino",
  oseoavic: "oseoavic",
};

export const getLogoByCustomer = () => {
  switch (process.env.CUSTOMER_ID) {
    case customers.oseoavic:
      return LogoValais;
    case customers.sosticino:
      return LogoTessin;
  }
};

export const onlyCustomers = keys => {
  // Can get string as input
  // Ensure keys is always treated as an array
  if (!Array.isArray(keys)) {
    keys = [keys];
  }

  // Check the array of keys depending on the env
  let env = process.env.CUSTOMER_ID;
  return keys.includes(env);
};

export const getCopyRightByCustomer = () => {
  switch (process.env.CUSTOMER_ID) {
    case customers.oseoavic:
      return `AVIC ${new Date().getFullYear()}`;
    case customers.sosticino:
      return `DERMAN - ${new Date().getFullYear()}`;
  }
};

export const getTitleByCustomer = () => {
  switch (process.env.CUSTOMER_ID) {
    case customers.oseoavic:
      return "Plateforme AVIC (OSEO Valais)";
    case customers.sosticino:
      return `DERMAN`;
  }
};
